export const DeviceUtil = {
  isIE() {
    const ua = window.navigator.userAgent;
    const hasMSIE = ua.indexOf('MSIE ') > 0;
    const hasTrident = ua.indexOf('Trident/') > 0;
    const hasEdge = ua.indexOf('Edge/') > 0;
    return hasMSIE || hasTrident || hasEdge;
  },
};
